export default "__VITE_ASSET__C$RPqvcp__"